import { render, staticRenderFns } from "./rolesIndex.vue?vue&type=template&id=09b05f62&"
import script from "./rolesIndex.vue?vue&type=script&lang=js&"
export * from "./rolesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports